/**
 * Constants for Create Organization page.
 * Single source of truth: industry options, copy, validation messages, step labels.
 */

export const INDUSTRY_OPTIONS = [
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'education', label: 'Education' },
  { value: 'retail', label: 'Retail' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'office', label: 'Office & Corporate' },
  { value: 'other', label: 'Other' },
];

export const PAGE_COPY = {
  TITLE: 'Create Your Organization',
  STEP_COUNTER_PREFIX: 'STEP',
  STEP_COUNTER_SUFFIX: 'OF',
  STEP_LABEL_ORGANIZATION: 'Organization Details',
  STEP_LABEL_ADMIN: 'Primary Administrator',
  BUTTON_PREVIOUS: 'Go Back',
  BUTTON_NEXT: 'Continue',
  BUTTON_SUBMIT: 'Create Organization',
  BUTTON_SUBMITTING: 'Submitting...',
};

export const TOTAL_STEPS = 2;

export const ERROR_MESSAGES = {
  VALIDATION_STEP_1: 'Please complete all required fields in Step 1.',
  CREATE_ORGANIZATION: 'Failed to create organization. Please try again.',
};

export const TOAST_CONFIG = {
  TITLE_SUCCESS: 'Success',
  TITLE_ERROR: 'Error',
  TITLE_VALIDATION: 'Validation Error',
  SUCCESS_COPY: 'Organization created successfully!',
};

/** Delay before navigating after success (ms) */
export const NAV_DELAY_MS = 1000;
